import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { BaseCheckbox } from "../../atoms/BaseCheckbox";
import { Label, LabelText, Root } from "./styles";

type CheckboxProps = {
  /**
   * The label for the field.
   */
  children: ReactNode;
} & ComponentPropsWithoutRef<typeof BaseCheckbox>;

/**
 * A Checkbox with a wrapping label.
 */
export function Checkbox({ children, ...rest }: CheckboxProps): JSX.Element {
  return (
    <Root data-testid={Checkbox.name}>
      <Label>
        <BaseCheckbox {...rest} />
        <LabelText isDisabled={rest.disabled}>{children}</LabelText>
      </Label>
    </Root>
  );
}
